module.exports = __webpack_public_path__ + "img/RIA.c52733c2.svg";